import { Button, FormControl, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactToPrint from "react-to-print";
import { ListagemIssqn } from "../../Components/Empresa/ListagemIssqn";

import { RelatorioHeader } from "../../Components/Empresa/RelatorioHeader";
import { CheckBox } from "../../Components/Empresa/RelatorioHeader/checkBox";
import { HeaderRelatorioImpresso } from "../../Components/Empresa/RelatorioHeader/HeaderRelatorioImpresso";
import { Empresa } from "../../Hooks/UsuarioHook";
import { useIssqn } from "../../Storage/issqn";

export const VisualizacaoGeral = () => {
  const { issqnInformado, getIssqnInformado, setColunas } = useIssqn();
  const [mes, setMes] = useState(
    new Date().getMonth().toString().padStart(2, "0")
  );
  const [ano, setAno] = useState(new Date().getFullYear().toString());

  const [mesFinal, setMesFinal] = useState(
    new Date().getMonth().toString().padStart(2, "0")
  );
  const [anoFinal, setAnoFinal] = useState(new Date().getFullYear().toString());

  const [print, setPrint] = React.useState(false);

  const conponentRef = React.useRef(null);

  const [alterados, setAlterados] = useState(false);

  useEffect(() => {

    setColunas({
      PERIODO: true,
      STATUS: false,
      BASE: true,
      ISSQN: true,
      INFORMANTE: false,
      DATA_INFORMACAO: false,
      MOTIVO: true,
      VENCIMENTO: false,
      CODIGO: false,
      BASE_CALCULADA: true,
      VALOR_CALCULADO: true,
    });
  }, []);


  useEffect(()=>{
    if(Number(mes) == 0){
      setMes('12');
      setAno((new Date().getFullYear()-1).toString())
    }
    if(Number(mesFinal) == 0){
      setMesFinal('12');
      setAnoFinal((new Date().getFullYear()-1).toString())
    }
  },[])


  useEffect(() => {
    getIssqnInformado(`${mes}-${ano}`, `${mesFinal}-${anoFinal}`);
  }, [mes, ano, mesFinal, anoFinal]);

  return (
    <div
      style={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          //   minWidth: "600px"
          // backgroundColor:"red",
          minWidth: window.screen.width >= 800 ? "700px" : "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ fontSize: 16 }}>DE:</span>
          <FormControl style={{ maxWidth: "150px" }}>
            <TextField
              id="filled-basic"
              label="Mês"
              variant="filled"
              type={"number"}
              value={mes}
              onChange={(ev) => {
                let mes = Number(ev.target.value);
               
                if (Number(ev.target.value) > 12) {
                  setAno(prev=>(Number(prev)+1).toString());
                  mes = 1;
                } else if (Number(ev.target.value) < 1) {
                  setAno(prev=>(Number(prev)-1).toString());
                  mes = 12;
                }
                setMes(mes.toString().padStart(2,'0'))

              }}
            />
          
          </FormControl>
          <Typography variant="h4" component="h1">
            /
          </Typography>
          <FormControl style={{ maxWidth: "150px" }}>
            <TextField
              id="filled-basic"
              label="Ano"
              variant="filled"
              type={"number"}
              value={ano}
              onChange={(ev) => {
                
                if (ev.target.value > ano) {
                  setMes((1).toString().padStart(2,'0'));
                } else if (ev.target.value < ano) {
                  setMes((12).toString().padStart(2,'0'));
                }

                  setAno(ev.target.value)
              }}
            />
          </FormControl>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ fontSize: 16 }}>ATÉ:</span>
          <FormControl style={{ maxWidth: "150px" }}>
            <TextField
              id="filled-basic"
              label="Mês"
              variant="filled"
              type={"number"}
              value={mesFinal}
              onChange={(ev) => {
                let mes = Number(ev.target.value);
               
                if (Number(ev.target.value) > 12) {
                  setAno(prev=>(Number(prev)+1).toString());
                  mes = 1;
                } else if (Number(ev.target.value) < 1) {
                  setAno(prev=>(Number(prev)-1).toString());
                  mes = 12;
                }
                setMesFinal(mes.toString().padStart(2,'0'));

              }}
            />
          </FormControl>
          <Typography variant="h4" component="h1">
            /
          </Typography>
          <FormControl style={{ maxWidth: "150px" }}>
            <TextField
              id="filled-basic"
              label="Ano"
              variant="filled"
              type={"number"}
              value={anoFinal}
              onChange={(ev) => {
                
                if (ev.target.value > anoFinal) {
                  setMesFinal((1).toString().padStart(2,'0'));
                } else if (ev.target.value < anoFinal) {
                  setMesFinal((12).toString().padStart(2,'0'));
                }

                  setAnoFinal(ev.target.value)
              }}
            />
          </FormControl>
        </div>

        <ReactToPrint
          content={() => conponentRef.current}
          trigger={() => {
            return (
              <Button variant="contained" onClick={() => {}}>
                IMPRIMIR
              </Button>
            );
          }}
          onBeforeGetContent={() => {
            setPrint(true);
          }}
          onAfterPrint={() => {
            setPrint(false);
          }}
        />
        {/* <MenuOpcoes
          alterados={alterados}
          setAlterados={setAlterados}
          telaRelatorios={true}
        /> */}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <CheckBox />
      </div>
      <ListagemIssqn />

      <div style={{ display: print ? "flex" : "none" }}>
        <div ref={conponentRef}>
          <HeaderRelatorioImpresso
            empresa={{} as Empresa}
            periodoInicial={{ mes: Number(mes), ano: Number(ano) }}
            periodoFinal={{ mes: Number(mesFinal), ano: Number(anoFinal) }}
          />

          <ListagemIssqn imprimir={true} />
        </div>
      </div>
    </div>
  );
};
